import useInbox from "../useInbox"

const useForm12Inbox = ({ tenantId, filters, config }) => {
    let citytenantId = Digit.ULBService.getCurrentTenantId();
    const userInfo = Digit.UserService.getUser();
    const type = userInfo?.info?.type
    if(type === "CITIZEN"){
        const district = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.CITY")
        citytenantId = district?.code || 'hp'
    }
    const {applicationStatus, mobileNumber, applicationNumber, sortBy, sortOrder, locality, uuid, limit, offset } = filters
    const USER_UUID = Digit.UserService.getUser()?.info?.uuid;
    const tcpBussinessIds = ["BPA_LOW", "BPA", "BPA_OC", "BPA_TCPBBNDA"]
    const udBussinessIds = ["BPA_UDSOLAN", "BPA_UDPARWANOO", "BPA_UDARKI", "BPA_UDTHEOG", "BPA_UDSHIMLA"]
    const BussinessIds = citytenantId.includes("ud") ? udBussinessIds : tcpBussinessIds
    const _filters = {
        tenantId,
		processSearchCriteria: {
            moduleName: "bpa-services",
			businessService: BussinessIds, // needs improvement
            assignee: "",
            ...(applicationStatus?.length > 0 ? {status: applicationStatus} : {}),
            ...(uuid && Object.keys(uuid).length > 0 ? {assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""} : {}),
        },
		moduleSearchCriteria: {
            sortOrder: "DESC",
            ...(mobileNumber ? {mobileNumber}: {}),
            ...(applicationNumber ? {applicationNumber} : {}),
            ...(sortBy ? {sortBy} : {}),
            // ...(sortOrder ? {sortOrder} : {}),
            ...(locality?.length > 0 ? {locality: locality.map((item) => item.code.split("_").pop()).join(",")} : {}),
        },
        limit,
        offset
    }

    return useInbox({tenantId, filters: _filters, config:{
        select: (data) =>({
            statuses: data.statusMap,
            table: data?.items.map( application => ({
                applicationId: application.businessObject.applicationNo,
                date: application?.businessObject?.auditDetails?.createdTime || application?.ProcessInstance?.auditDetails?.createdTime,
                businessService: application.businessObject.businessService,
                locality: `${application.businessObject?.tenantId?.toUpperCase()?.split(".")?.join("_")}_REVENUE_${application.businessObject?.landInfo?.address?.locality?.code.split('.')?.[1]?.toUpperCase()}`,
                status: application.businessObject.status,
                owner: application?.businessObject?.landInfo?.owners?.[0]?.name || "NA",
                dairyNo: application?.businessObject?.tcpDairyNumber,
                sla: Math.round(application.ProcessInstance?.businesssServiceSla / (24 * 60 * 60 * 1000))
            })),
            totalCount: data.totalCount
        }),
        ...config
    }})
}

export default useForm12Inbox